import './LiveHistoryMsg.sass';

import React, { FC } from 'react';
import { UnitName, UnitPhoto, Verified } from '$shared/components';
import { LiveHistoryMsgProps } from '$core/Live/LiveHistoryMsg/LiveHistoryMsg.interface';
import { useUserInfo } from '$hooks';
import { classNames as cn } from '$utils';

export const LiveHistoryMsg: FC<LiveHistoryMsgProps> = ({
  userId,
  message,
  info,
  sponsor,
  marked,
  pending,
  onClick,
}) => {
  const user = useUserInfo(userId || 0);
  return (
    <div
      className={cn('LiveHistoryMsg', {
        marked,
        pending,
        active: onClick,
      })}
      onPointerUp={onClick ? () => onClick(user) : undefined}
    >
      <UnitPhoto
        routeName={onClick ? null : undefined}
        size="extra-small"
        onlineIndicator={false}
        nftIndicator={false}
        unit={user}
      />
      <div className="LiveHistoryMsg__body">
        <div className="LiveHistoryMsg__body__title">
          <div className="LiveHistoryMsg__body__title__userName">
            <UnitName unit={user} />
            {sponsor && <Verified objectId={0} sponsor />}
          </div>
          {info && <div className="LiveHistoryMsg__body__title__info">{info}</div>}
        </div>
        {message && <div className="LiveHistoryMsg__body__message">{message}</div>}
      </div>
    </div>
  );
};
